document.addEventListener("DOMContentLoaded", () => {
    const containers = document.querySelectorAll(".statsContainer");
    if (!containers.length) return;

    const animatedContainers = new WeakSet();
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const extractNumberParts = text => {
        const digitsOnly = text.replace(/[^\d.]/g, "");
        const normalisedNumber = digitsOnly.replace(/(?<=\d)\.(?=\d{3}\b)/g, "");
        const number = parseFloat(normalisedNumber) ||
            parseInt(digitsOnly.replace(/[^\d]/g, ""), 10);
        const decimalPlaces = normalisedNumber.includes(".") ? normalisedNumber.split(".")[1].length : 0;
        const prefix = text.match(/^\D+/)?.[0] || "";
        const suffix = text.match(/\D+$/)?.[0] || "";
        return { number: Number.isFinite(number) ? number : NaN, decimalPlaces, prefix, suffix };
    };

    const formatValue = (value, decimalPlaces) => value.toLocaleString("en-GB", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });

    const animateValue = (el, target, { duration = 1500, decimalPlaces = 0, prefix = "", suffix = "" } = {}) => {
        if (prefersReducedMotion) {
            el.textContent = `${prefix}${formatValue(target, decimalPlaces)}${suffix}`;
            return;
        }

        const startTime = performance.now();

        const tick = now => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            const current = progress === 1
                ? target
                : Number((eased * target).toFixed(decimalPlaces));
            el.textContent = `${prefix}${formatValue(current, decimalPlaces)}${suffix}`;
            if (progress < 1) requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
    };

    const animateContainer = container => {
        if (animatedContainers.has(container)) return;
        animatedContainers.add(container);

        const items = container.querySelectorAll(".statsValue");
        items.forEach(el => {
            if (el.dataset.animated === "true") return;

            const raw = el.textContent.trim();
            const { number, decimalPlaces, prefix, suffix } = extractNumberParts(raw);
            if (!Number.isFinite(number)) return;

            const customDuration = parseInt(el.getAttribute("data-duration"), 10);
            animateValue(el, number, {
                duration: Number.isFinite(customDuration) ? customDuration : 1500,
                decimalPlaces,
                prefix,
                suffix
            });

            el.dataset.animated = "true";
        });
    };

    // Trigger countUp with 1 second delay when it comes into view
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => animateContainer(entry.target), 250);
            }
        });
    }, { threshold: 0.3 });

    containers.forEach(container => observer.observe(container));
});
